import { useLottie } from 'lottie-react'
import loading from '#app/assets/json/otemba-grain.json'

export const Animation = () => {
	const style = {
		height: 300,
	}

	const options = {
		animationData: loading,
		loop: true,
		autoplay: true,
	}

	const { View } = useLottie(options, style)

	return <>{View}</>
}
